import {ROW_SECTION_MAX_WIDTH} from '../components/molecules/SplitViewGrid/RowSectionGrid';
import {SPACING} from './sizing';

export const GRID_TOTAL_COLUMNS = 12;
const MAX_WIDTH = ROW_SECTION_MAX_WIDTH;
export const GRID_GUTTER_WIDTH = SPACING['X.Md'];
const GRID_GUTTER_TOTAL_WIDTH = `(${GRID_TOTAL_COLUMNS} - 1) * ${GRID_GUTTER_WIDTH}`;

export const gridContainer = `
  display: flex;
  gap: ${GRID_GUTTER_WIDTH};
`;

export const gridOffsetWidth = (span = 1) => `
  calc(${gridColsWidth(span)} + ${GRID_GUTTER_WIDTH} * 2)
`;

export const gridColsWidth = (span = 1) => `
  calc((min(${MAX_WIDTH}px, 100vw) - ${GRID_GUTTER_TOTAL_WIDTH} - max(var(--row-section-padding, 0px), ${SPACING['X.Lg']}) * 2) / ${GRID_TOTAL_COLUMNS} * ${span} + ${GRID_GUTTER_WIDTH} * (${span} - 1))
`;

export const gridCols = (span = 1) => `
  width: ${gridColsWidth(span)};
`;
